import { render, staticRenderFns } from "./VerifyUser.vue?vue&type=template&id=4512ce22&scoped=true"
import script from "./VerifyUser.vue?vue&type=script&lang=ts"
export * from "./VerifyUser.vue?vue&type=script&lang=ts"
import style0 from "./VerifyUser.vue?vue&type=style&index=0&id=4512ce22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4512ce22",
  null
  
)

export default component.exports